import React, { useState } from 'react';
import './FAQSection.css'; // Import CSS for styling

const faqs = [
  {
    id: 1,
    question: 'How does Fably work?',
    answer: 'Fably uses AI to analyze your text and automatically create engaging short videos based on your selected style and preferences.'
  },
  {
    id: 2,
    question: 'What kind of content can I request?',
    answer: 'Since we are using an AI provider for content summaries, we can only summarize content that are available on the internet. All the summaries are based on our AI provider\'s database.'
  },
  {
    id: 3,
    question: 'I am an author, can I use Fably to create a video summary of my book?',
    answer: 'Yes you can, just upload your book and we will create a video summary of it.'
  },
  {
    id: 4,
    question: 'My video has not arrived in my inbox, what should I do?',
    answer: 'If your video has not arrived in your inbox after an hour and a half, please contact us at bisbis@fably.com'
  },
  {
    id: 5,
    question: 'How long are the videos?',
    answer: 'The videos are at least 60 seconds long but can be as long as 90 seconds.'
  },
  {
    id: 6,
    question: 'What do I get when I buy an animation?',
    answer: 'You get a 60 second video summary of the content you uploaded with complete voiceover!'
  },
  
];

const FAQSection = () => {
  // State to track the currently open accordion item index (start with first open)
  const [activeIndex, setActiveIndex] = useState(0);

  const handleToggle = (index) => {
    // If the clicked item is already open, close it by setting activeIndex to null
    // Otherwise, set the activeIndex to the clicked item's index
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="faq-container">
        {/* Optional Header based on sample */}
        <div className="faq-header">
          <h6 className="faq-subtitle">FAQs</h6>
          <h2 className="faq-title">Frequently asked questions</h2>
        </div>

        <div className="accordion-group">
          {faqs.map((faq, index) => {
            const isActive = activeIndex === index;
            const contentId = `faq-content-${faq.id}`;
            return (
              <div key={faq.id} className={`accordion-item ${isActive ? 'active' : ''}`}>
                <button 
                  className="accordion-toggle"
                  aria-controls={contentId}
                  aria-expanded={isActive}
                  onClick={() => handleToggle(index)}
                >
                  <span className="question">{faq.question}</span>
                  {/* Icon changes based on state, handled by CSS */}
                  <span className="icon" aria-hidden="true"></span> 
                </button>
                <div 
                  id={contentId} 
                  className="accordion-content"
                  // Role region is good practice for content revealed by accordions
                  role="region"
                  aria-labelledby={`faq-question-${faq.id}`} // Points back to question if needed
                >
                  <p id={`faq-question-${faq.id}`}>{faq.answer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQSection; 